import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
const TypeCostList = React.lazy(() => import('./Table'));
const TypeCostCreate = React.lazy(() => import('./CreateForm'));

export const vTypeConfigs = [
  {
    permittedRole: [ RoutePermittedRole.corporateAdmin,  RoutePermittedRole.vendor],
    path: '/onboard-corporate/vehicle-cost/listing',
    element: <TypeCostList />,
  },
  {
    permittedRole: [ RoutePermittedRole.corporateAdmin,  RoutePermittedRole.vendor],
    path: '/onboard-corporate/vehicle-cost/create-form',
    element: <TypeCostCreate/>,
  },
];
